export default __webpack_public_path__ + "static/media/Exclusion.4ae74deb.svg";